const gsap = window.gsap;
if (gsap !== undefined) {
  // ── Spinner setup ────────────────────────────────────────────────────────────
  const spinner = document.createElement("div");
  spinner.id = "page-transition-spinner";
  spinner.innerHTML = `<div class="spinner-ring"></div>`;
  spinner.style.cssText = `
    position: fixed; inset: 0; z-index: 9999;
    display: flex; align-items: center; justify-content: center;
    pointer-events: none; opacity: 1;
  `;
  const style = document.createElement("style");
  style.textContent = `
    .spinner-ring {
      opacity: 0;
      width: 36px; height: 36px; border-radius: 50%;
      border: 3px solid rgba(0,0,0,0.12);
      border-top-color: red;
      animation: spin 0.7s linear infinite;
    }
    @keyframes spin { to { transform: rotate(360deg); } }
  `;
  document.head.appendChild(style);
  document.body.appendChild(spinner);

  const SLOW_THRESHOLD = 1000;

  document.addEventListener("DOMContentLoaded", () => {
    const loadTime = performance.now();

    if (loadTime > SLOW_THRESHOLD) {
      gsap.to(spinner, {
        opacity: 1,
        duration: 0.15,
        ease: "power1.in",
        onComplete: () => {
          gsap.fromTo(
            ".main, .header",
            { opacity: 0 },
            { autoAlpha: 1, opacity: 1, duration: 0.3, ease: "power1.out" }
          );
        },
      });
    } else {
      // gsap.to(spinner, { opacity: 0 });
      gsap.fromTo(
        ".main, .header",
        { opacity: 0 },
        { autoAlpha: 1, opacity: 1, duration: 0.3, delay: 0.1, ease: "power1.out" }
      );
    }

    // ── 2. Fade OUT on navigation ────────────────────────────────────────────
    document.querySelectorAll("a").forEach((link) => {
      if (shouldSkip(link)) return;
      link.addEventListener("click", (e) => {
        const href = link.getAttribute("href");
        e.preventDefault();
        gsap.to(".main, .header", {
          autoAlpha: 0,
          opacity: 0,
          duration: 0.3,
          ease: "power1.in",
          onComplete: () => {
            window.location.href = href;
          },
        });
      });
    });

    // ── 3. Restore opacity if user hits Back ─────────────────────────────────
    window.addEventListener("pageshow", (e) => {
      if (e.persisted) {
        gsap.to(spinner, { opacity: 0 });
        gsap.to(".main, .header", { autoAlpha: 1, opacity: 1, duration: 0.3, ease: "power1.out" });
      }
    });
  });

  // ── Helpers ──────────────────────────────────────────────────────────────────
  function shouldSkip(link) {
    const href = link.getAttribute("href");
    if (!href) return true;
    if (href.startsWith("#")) return true;
    if (href.startsWith("mailto:")) return true;
    if (href.startsWith("tel:")) return true;
    if (link.target === "_blank") return true;
    if (link.hasAttribute("download")) return true;
    try {
      const url = new URL(href, window.location.origin);
      if (url.origin !== window.location.origin) return true;
    } catch (_) {
      return true;
    }
    return false;
  }
}
